import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { TopNavbar } from '../../ui/top-navbar'
import { Footerdemo } from '../../ui/footer-section'
import { Button } from '@/components/ui/button'
import { Menu } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Sheet, SheetContent } from '@/components/ui/sheet'
import { UTMLink } from '@/components/custom-ui/utm-link'
// import logoLarge from '@/assets/logo-large.png' // TODO: Add logo file
import { ThemeToggle } from '@/components/ui/theme-toggle'

export default function UnauthenticatedLayout() {
  const location = useLocation()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  
  // List of paths where we don't want to show the navbar and footer
  const hideUIElements = [
    '/login',
    '/auth/callback',
    '/onboarding',
    // '/lp-rainfactory-suite', // Remove from here
    // Add any other paths where UI elements should be hidden
  ]
  
  // Paths where we only want to hide the navbar but show the footer
  const hideNavbarOnly = [
    '/lander1'
  ]

  // Navigation links
  const navLinks = [
    { name: 'Products', path: '/products' },
    { name: 'Services', path: '/services' },
    // { name: 'Pricing', path: '/pricing' }, // Pricing removed
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ]

  // Check if current path starts with any of the hideUIElements paths
  const shouldShowElements = !hideUIElements.some(path => 
    location.pathname.startsWith(path)
  )
  
  // Check if current path starts with any path where we only hide navbar
  const shouldHideNavbarOnly = hideNavbarOnly.some(path => 
    location.pathname.startsWith(path)
  )

  return (
    <div className="min-h-[100dvh] flex flex-col">
      {shouldShowElements && !shouldHideNavbarOnly && (
        <>
          {/* Mobile Menu Button - positioned to work with sticky header */}
          <Button
            variant="ghost"
            size="icon"
            className="fixed top-4 left-4 z-[60] md:hidden bg-background/80 backdrop-blur-sm border shadow-sm"
            onClick={() => setMobileMenuOpen(true)}
          >
            <Menu className="h-5 w-5" />
          </Button>
          
          {/* Mobile Menu */}
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetContent side="left" className="p-0 border-r">
              <div className="flex flex-col p-6 space-y-6">
                <div className="flex items-center mb-2">
                  <UTMLink to="/" className="flex items-center" onClick={() => setMobileMenuOpen(false)}>
                    <div className="h-8 w-8 mr-2 bg-primary rounded-lg flex items-center justify-center">
                      <span className="text-primary-foreground font-bold text-sm">RR</span>
                    </div>
                    <span className="font-semibold text-lg">RoboRelay</span>
                  </UTMLink>
                </div>
                
                <nav className="space-y-2">
                  {navLinks.map((link) => (
                    <UTMLink
                      key={link.path}
                      to={link.path}
                      className={cn(
                        "block w-full font-medium text-lg py-3 px-3 transition-colors hover:text-foreground/80 hover:bg-muted rounded-md",
                        location.pathname === link.path ? "text-foreground bg-muted" : "text-foreground/60"
                      )}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {link.name}
                    </UTMLink>
                  ))}
                </nav>
                
                <div className="pt-4 border-t">
                  <UTMLink to="/login" onClick={() => setMobileMenuOpen(false)}>
                    <Button className="w-full py-5 text-base">Log In</Button>
                  </UTMLink>
                </div>
                
                <div className="pt-4 border-t flex justify-center">
                  <ThemeToggle />
                </div>
              </div>
            </SheetContent>
          </Sheet>
          
          {/* Sticky Header */}
          <TopNavbar 
            showProfile={false} 
            className={cn(
              "sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60",
              mobileMenuOpen ? "md:block hidden" : ""
            )} 
          />
        </>
      )}
      <main className={`flex-grow ${shouldShowElements && !shouldHideNavbarOnly ? 'pt-0' : ''}`}>
        <Outlet />
      </main>
      {shouldShowElements && <Footerdemo />}
    </div>
  )
}